// Note saves that outlive the card that started them.
//
// Turbo replaces the body on every visit, so a card is regularly torn down with
// a debounced save still queued. The document survives the visit, so the request
// can too: this module sends it and remembers what the server accepted, keyed by
// note id and by the card's client key. note-card adopts that record when it
// connects, which is how a create started by one card finishes on another, and
// how a version token stays current across a visit.

import { fetchWithCSRF } from "./fetch"

const accepted = new Map()

// What the server last accepted for this note, if this page has saved it.
export function acceptedSave(key) {
    return accepted.get(key)
}

// PATCH when the note exists, POST to create it otherwise. Returns
// { ok: true, id, version, createdAt } or { ok: false, status }. A network
// failure throws, which callers treat as retryable.
export async function saveNote({ key, id, version, content, createUrl, keepalive = false }) {
    const request = id
        ? {
              url: `/frame/notes/${id}`,
              method: "PATCH",
              body: { content, version },
          }
        : { url: createUrl, method: "POST", body: { content } }

    let response = await send(request, keepalive)
    // A 403 means the CSRF token rotated mid-session. fetchWithCSRF has already
    // taken the fresh one from the response headers, so one retry lands.
    if (response.status === 403) response = await send(request, keepalive)
    if (!response.ok) return { ok: false, status: response.status }

    const data = await response.json()
    const record = {
        id: id || data.id,
        version: data.version || version,
        createdAt: data.created_at,
    }
    accepted.set(key, record)
    if (record.id) accepted.set(record.id, record)
    return { ok: true, ...record }
}

function send({ url, method, body }, keepalive) {
    return fetchWithCSRF(url, {
        method,
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(body),
        keepalive,
    })
}
